/**
 * HelperMixin
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Miscelaneous functions, helpers and tools (not for UI or business logic)
 * @since 2021-08-30
**/
export var helperMixin = {
  data: function() {
    return {
      trackData: [],
      interval: null
    };
  },
  methods: {
    getImageUrl (imagePath) {
      return require(`@/assets/images/${imagePath}`);
    },

    getFlagUrl: function(iso) {
      try {
        return require(`@/assets/images/landing-page/flags/${iso}.svg`);
      } catch (ex) {
        return '';
      }
    },

    // SmartLook Analytics Event
    trackEvent (name, properties) {
      properties = properties || null;

      if (window.smartlook) {
        window.smartlook('track', name, properties);
      } else {
        this.trackData.push([name, properties]);

        if (this.interval === null) {
          this.interval = setInterval(() => {
            if (!window.smartlook) {
              return;
            }

            clearInterval(this.interval);

            this.trackData.forEach(entry => {
              window.smartlook('track', entry[0], entry[1]);
            });
          }, 10);
        }
      }
    },

    loadImageSources (selector) {
      const images = document.querySelectorAll(selector);

      Array.from(images).forEach(e => {
        const img = new Image();

        img.src = (window.devicePixelRatio && window.devicePixelRatio > 1) ? e.dataset.srcHd : e.dataset.srcSd;

        img.onload = () => {
          e.src = img.src;
          e.classList.remove('u-loading-image');
        };
      });
    },

    webPFormat (fallbackFormat) {
      fallbackFormat = fallbackFormat || 'jpeg';

      if (this.$store.getters.getBrowser.getBrowserName().match(/safar/gi) && Number(this.$store.getters.getBrowser.getBrowserVersion()) < 14) {
        return fallbackFormat;
      }

      return 'webp';
    }
  }
};
